import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface PreviewArticle {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  categoryTag: string;
  date: string;
}

const previewArticles: PreviewArticle[] = [
  {
    slug: 'kakobuy-sneakers-najlepsze-znaleziska',
    title: 'Kakobuy Sneakers – Najlepsze Znaleziska i Linki do Butów 2026',
    excerpt: 'Odkryj setki zweryfikowanych linków do sneakersów Nike, Adidas, Jordan i New Balance. Jakość, ceny i bezpieczeństwo zakupów w jednym miejscu.',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20sneakers%20flat%20lay%20arrangement%20with%20multiple%20pairs%20of%20white%20minimalist%20leather%20trainers%20and%20classic%20canvas%20shoes%20on%20warm%20terracotta%20toned%20surface%2C%20natural%20sunlight%20from%20window%20casting%20soft%20shadows%2C%20editorial%20fashion%20product%20photography%2C%20clean%20modern%20European%20aesthetic&width=800&height=500&seq=art-prev-02&orientation=landscape',
    categoryTag: 'Sneakers',
    date: '18 lipca 2026',
  },
  {
    slug: 'kakobuy-hoodies-bluzy-przewodnik',
    title: 'Kakobuy Hoodies & Bluzy – Kompletny Przewodnik po Najlepszych Ofertach',
    excerpt: 'Szukasz idealnej bluzy z dostawą do Polski? Setki linków do bluz, swetrów i streetwearu w niskich cenach z Chin. Sprawdź nasz ranking.',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20cozy%20oversized%20cotton%20hoodies%20in%20neutral%20earth%20tones%20folded%20neatly%20on%20warm%20beige%20linen%20fabric%20surface%2C%20soft%20natural%20window%20light%2C%20minimalist%20Scandinavian%20fashion%20product%20photography%2C%20clean%20editorial%20composition%20with%20organic%20textile%20textures&width=800&height=500&seq=art-prev-03&orientation=landscape',
    categoryTag: 'Hoodies',
    date: '16 lipca 2026',
  },
  {
    slug: 'kakobuy-tshirts-koszulki-poradnik',
    title: 'Kakobuy T-Shirts – Najlepsze Koszulki w Niskich Cenach z Chin',
    excerpt: 'Koszulki basic, streetwear i designerskie inspiracje – wszystko z dostawą do Polski w atrakcyjnych cenach. Setki modeli w Kakobuy Spreadsheet.',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20arrangement%20of%20assorted%20cotton%20t-shirts%20in%20soft%20pastel%20and%20earth%20tone%20colors%20folded%20neatly%20on%20warm%20cream%20linen%20surface%2C%20natural%20daylight%20from%20side%20window%2C%20clean%20contemporary%20fashion%20photography%2C%20European%20editorial%20style%20with%20organic%20fabric%20textures&width=800&height=500&seq=art-prev-07&orientation=landscape',
    categoryTag: 'T-Shirts',
    date: '10 lipca 2026',
  },
  {
    slug: 'kakobuy-jackets-kurtki-przewodnik',
    title: 'Kakobuy Jackets – Kurtki i Płaszcze z Chin w Najlepszych Cenach',
    excerpt: 'Od lekkich bomberek po puchowe parki zimowe. Sprawdzone linki, jakość wykonania i rzeczywiste opinie kupujących. Oszczędzaj na modzie.',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20modern%20bomber%20jacket%20and%20winter%20coat%20in%20neutral%20olive%20and%20beige%20tones%20on%20warm%20cream%20fabric%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20fashion%20product%20photography%2C%20clean%20European%20minimalist%20aesthetic%20with%20sophisticated%20textile%20details&width=800&height=500&seq=art-prev-08&orientation=landscape',
    categoryTag: 'Jackets',
    date: '8 lipca 2026',
  },
  {
    slug: 'kakobuy-accessories-akcesoria',
    title: 'Kakobuy Accessories – Akcesoria Modowe w Super Cenach z Chin',
    excerpt: 'Zegarki, okulary, paski, czapki – setki stylowych dodatków z dostawą do Polski. Sprawdź nasze rekomendacje i zweryfikowane linki do produktów.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20fashion%20accessories%20including%20minimalist%20watch%20leather%20belt%20sunglasses%20and%20bracelet%20on%20warm%20cream%20linen%20surface%2C%20soft%20natural%20daylight%2C%20sophisticated%20editorial%20product%20photography%2C%20clean%20European%20luxury%20aesthetic%20with%20refined%20composition&width=800&height=500&seq=art-prev-09&orientation=landscape',
    categoryTag: 'Akcesoria',
    date: '6 lipca 2026',
  },
  {
    slug: 'kakobuy-jak-kupowac-bezpiecznie',
    title: 'Czy Kakobuy jest bezpieczny? Kompletny Poradnik Bezpieczeństwa 2026',
    excerpt: 'Wszystko o bezpieczeństwie zakupów przez Kakobuy. Weryfikacja sprzedawców, ochrona przed oszustwami, zdjęcia QC i bezpieczne płatności.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20workspace%20scene%20with%20a%20modern%20laptop%20displaying%20security%20shield%20icon%2C%20smartphone%20and%20credit%20card%20on%20warm%20cream%20desk%20surface%2C%20soft%20natural%20daylight%2C%20concept%20of%20safe%20online%20shopping%2C%20European%20editorial%20style%20photography%2C%20professional%20trustworthy%20atmosphere&width=800&height=500&seq=art-prev-04&orientation=landscape',
    categoryTag: 'Bezpieczeństwo',
    date: '15 lipca 2026',
  },
  {
    slug: 'kakobuy-dla-poczatkujacych',
    title: 'Kakobuy dla Początkujących – Poradnik od A do Z 2026',
    excerpt: 'Zaczynasz przygodę z Kakobuy? Przeprowadzimy Cię przez cały proces – od rejestracji po pierwsze udane zamówienie z Chin do Polski.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20beginner%20guide%20concept%20with%20open%20notebook%20handwritten%20notes%20smartphone%20and%20shopping%20cart%20on%20warm%20cream%20desk%20surface%2C%20soft%20natural%20daylight%2C%20friendly%20approachable%20editorial%20photography%20style%2C%20European%20minimalist%20aesthetic%20with%20welcoming%20atmosphere&width=800&height=500&seq=art-prev-05&orientation=landscape',
    categoryTag: 'Poradnik',
    date: '14 lipca 2026',
  },
  {
    slug: 'kakobuy-wysylka-do-polski',
    title: 'Kakobuy Wysyłka do Polski – Koszty, Czas i Metody Dostawy 2026',
    excerpt: 'Kompletny przewodnik po wysyłce Kakobuy do Polski. Porównanie metod dostawy, koszty, cło i VAT. Wszystko co musisz wiedzieć przed zamówieniem.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20shipping%20and%20delivery%20concept%20with%20cardboard%20boxes%20packaging%20tape%20and%20shipping%20labels%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20organized%20editorial%20product%20photography%2C%20European%20modern%20aesthetic%20with%20logistics%20theme&width=800&height=500&seq=art-prev-06&orientation=landscape',
    categoryTag: 'Wysyłka',
    date: '12 lipca 2026',
  },
  {
    slug: 'kakobuy-spreadsheet-kompletny-przewodnik',
    title: 'Kakobuy Spreadsheet – Kompletny Przewodnik dla Kupujących 2026',
    excerpt: 'Wszystko o Kakobuy Spreadsheet w jednym miejscu. Jak znaleźć najlepsze produkty, linki, oferty i oszczędzać czas na zakupach z Chin.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20flat%20lay%20of%20a%20modern%20laptop%20with%20spreadsheet%20interface%20on%20screen%20surrounded%20by%20fashion%20accessories%20sneakers%20and%20shopping%20bags%20on%20warm%20cream%20beige%20surface%2C%20soft%20natural%20daylight%2C%20European%20editorial%20photography%20aesthetic%2C%20airy%20organized%20composition%20with%20gentle%20shadows&width=800&height=500&seq=art-prev-01&orientation=landscape',
    categoryTag: 'Przewodnik',
    date: '20 lipca 2026',
  },
];

export default function ArticlePreviewSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2 font-heading">
            {t('articles_title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('articles_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {previewArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group cursor-pointer bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300/60 transition-all duration-200 hover:scale-[1.02]"
            >
              <div className="w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-medium text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {article.categoryTag}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 font-heading leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <span className="whitespace-nowrap inline-flex items-center gap-1 text-xs font-semibold text-primary-500 group-hover:text-primary-600 transition-colors">
                  {t('article_read_more')}
                  <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}